import { getErrorMessage } from './getErrorMessage';
export const getError = e => e instanceof Error ? e : new Error(getErrorMessage(e));